<template>
  <div id="app">
    <div id="v3TopEmpty" @click="onEmptyClick()"></div>
    <div id="v3MainContent" :style="{ height: contentHeight }">
      <TabBar ref="v3TabBar" id="v3Menu" :typeList="typeList" :itemHeight="itemHeight" @clickitem="clickitem"></TabBar>
      <div id="v3Content">
        <V3Mine v-if="showType == 'mine'" @missionclick="missionclick"></V3Mine>
        <!-- <keep-alive>
          <V3Rebate v-if="showType == 'rebate'" :needTimeCountOnTop="needTimeCountOnTop" :typeId="typeId"
            :showActivityBanner="showActivityBanner"></V3Rebate>
        </keep-alive> -->
        <V3Rebate v-if="showType == 'rebate'" :needTimeCountOnTop="needTimeCountOnTop" :typeId="typeId"
            :showActivityBanner="showActivityBanner" :typeType="typeType"></V3Rebate>
        <!-- <KeepAlive>
          <router-view></router-view>
        </KeepAlive> -->
      </div>
      <SdkV3Loading v-if="$store.state.showLoading" />
      <Toast v-if="$store.state.showToast" />
      <AlertConfirm v-if="$store.state.showAlert" />
    </div>
    <AlertWxBind v-if="$store.state.showWxBindPage" />
  </div>
</template>

<script>

import SdkV3Loading from "./SdkV3Loading.vue";
import AlertConfirm from "./AlertConfirm.vue";
import Toast from "views/alert/Toast.vue";
import utils from '@/utils';
import { request } from '@/SdkV3/network/request';
import getRequestParams from "@/signParams";
import TabBar from "./TabBar.vue";

import AlertWxBind from 'views/alert/AlertWxBind.vue';

import V3Mine from "./mine/V3Mine.vue";
import V3Rebate from "./rebate/V3Rebate.vue";

export default {
  name: 'App',
  data() {
    return {
      contentHeight: '70vh',
      timer: null,
      typeList: [],
      itemHeight: "",
      showType: "mine",
      needTimeCountOnTop: false,// 是否需要在页面上方展示时间倒计时等用户信息，除了我的，其他全部都要展示，只是只在登录和等级红包上面展示角色信息以及时间等，其他的展示规则，或者红包次数
      typeId: "",//红包类型id，用于获取红包列表数据
      showActivityBanner: false, //是否在红包列表上方展示活动banner
      typeName: "我的",//当前选择的红包的名称,
      typeType: "0", // typetype 红包类型（1：等级红包，2：登录红包，3：瓜分红包，4：充值红包，5：口令红包，6：抢红包）目前是为了在点击抢红包时。需要展示领取的图标跟普通的不一样
    }
  },
  components: {
    SdkV3Loading,
    Toast,
    TabBar,
    AlertWxBind,
    V3Mine, V3Rebate,AlertConfirm
  },
  mounted: function () {
    // 获取url中的param=后面的参数值，在这里携带的是{"key":"value"}的json形式
    let params = utils.getUrlKey("param")
    // 将获取到的参数更新到store中，方面后续获取公共参数
    this.$store.commit('updateCommonParams', params)

    // 从store获取公共参数,这些参数是在一开始就获取到的
    let storeCommomParams = this.$store.state.commonParameters

    // console.log("基本参数", storeCommomParams);

    // 使用公共参数转换成用于请求api需要的参数值形式
    let signParams = getRequestParams({}, storeCommomParams);
    // 先去获取rid，phone，更新到基本参数中去，再去请求红包初始化，红包用户信息
    request({
      url: this.urls.REBATE_INFO,
      params: {
        data: signParams // 在url后面加上&data=[signParams具体内容]
      },
    }).then(res => {
      // 更新公共参数中的rid和phone，不直接从原始公共参数中传递。是为了避免直接暴露rid
      this.$store.dispatch("networkUpdateRid", { "rid": res["rid"], "phone": res["phone"] })
      signParams = getRequestParams({}, storeCommomParams);
      let rebateInitReq = request({
        url: this.urls.REBATE_INIT,
        params: {
          data: signParams
        },
      })
      let rebateUser = request({
        url: this.urls.REBATE_USER,
        params: {
          data: signParams
        },
      })
      // 将红包初始化，和红包用户接口两个请求合并，当两个请求都成功才处理then里面的内容
      Promise.all([rebateInitReq, rebateUser]).then(values => {
        console.log(values);
        // 网络请求异步的数据，需要用 dispatch

        let userInfoData = values[1]
        let roleregTime = userInfoData['rolereg']
        console.log("角色时间", roleregTime);
        // 转换注册时间格式
        userInfoData['rolereg'] = this.formatDateTime(roleregTime)
        let payload = { "initData": values[0], "userInfoData": userInfoData }
        this.typeList = JSON.parse(values[0]['rebateType'])
        this.typeList.push({ 'typename': '我的', 'typesort': '0', 'typeid': '-1' , 'typetype': '-1'})
        // this.typeList.push({'typename': '随机红包', 'typesort':'2', 'typeid':'2'})
        // this.typeList.push({'typename': '我的', 'typesort':'3', 'typeid':'-1'})
        // this.typeList.push({'typename': '我的', 'typesort':'4', 'typeid':'-1'})
        // this.typeList.push({'typename': '我的', 'typesort':'5', 'typeid':'-1'})
        this.typeList.sort(function (a, b) { return a['typesort'] - b['typesort'] });
        this.itemHeight = (70 / this.typeList.length)
        this.$store.dispatch('networkHandleRebateAndUserInit', payload)

      })
    })
    // 通知安卓端，H5已经准备好，可以发送需要数据过来了，目前只要客服未读信息
    // this.sendToClient('sdkFinish?')
    setTimeout(() => {
      // document.querySelector('#v3TopEmpty').setAttribute('style', 'background-color:#000;opacity:0.5')
      const deTime = 2;
      const TIME_COUNT = 50;
      // alpha值需要最终显示0.5 ，然后在 TIME_COUNT 毫秒内，每 deTime 时间变一次，这里的 splitTime 是每 deTime 变一次需要加上的值
      const splitTime = 0.5 / (TIME_COUNT / deTime);
      let count = TIME_COUNT;
      let opacity = 0;
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (count > 0 && count <= TIME_COUNT) {
            count -= deTime;
            opacity += splitTime;
            let opacityValue = 'background-color:#000;opacity:' + opacity
            // console.log(opacityValue);
            document.querySelector('#v3TopEmpty').setAttribute('style', opacityValue)
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, deTime)
      }
    }, 240);

    // 是否是横屏,修改高度，方便滑動
    // if (storeCommomParams['landGame'] === 'true') {
    //   this.contentHeight = "85vh"
    // }
  },
  // mounted:function(){

  // },
  methods: {
    formatDateTime(inputTime) {
      // console.log("formatDateTime");
      if (inputTime.length == 10) {
        inputTime = inputTime * 1000
      }
      var date = new Date(inputTime);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      var h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? ('0' + minute) : minute;
      second = second < 10 ? ('0' + second) : second;
      return "创角时间："+ y + '年' + m + '月' + d + '日' + h + '时' + minute + '分';
    },
    missionclick() {
      this.$refs.v3TabBar.clickIndex(1)
    },
    clickitem(selectedItem) {
      // console.log("选择的item", selectedItem);
      this.typeName = selectedItem['typename']

      // typetype 红包类型（1：等级红包，2：登录红包，3：瓜分红包，4：充值红包，5：口令红包，6：抢红包）
      this.typeType = selectedItem['typetype']

      this.typeId = selectedItem['typeid']
      if ( this.typeName == '我的') {
        this.showType = "mine"
      } else {
          this.needTimeCountOnTop = true
        this.showType = "rebate"
        if ( this.typeName == '冲级红包' ||  this.typeName == '等级红包') {
          this.showActivityBanner = true //显示活动banner
        } else if ( this.typeName == '登录红包') {
          this.showActivityBanner = false//隐藏活动banner
        }else {
          this.showActivityBanner = false//隐藏活动banner
        }
      }
      // console.log("typeId", this.typeId);
    },
    setWxBindCallback() {
      // console.log("点击绑定微信");
      let storeCommomParams = this.$store.state.commonParameters
      // 这里显示绑定提取方式  ct=rebate&ac=wxAuth  获取微信绑定二维码展示
      let wxBindReqParams = getRequestParams({}, storeCommomParams);
      request({
        url: this.urls.REBATE_WXAUTH,
        params: {
          data: wxBindReqParams
        },
      }).then(res => {
        // console.log(res);
        // console.log(JSON.parse(res.param)['url']);
        if ("qrcode" == res.type) {
          let qrcodeUrl = JSON.parse(res.param)['url'];
          this.$store.dispatch('networkWxBindPageShow', { "showOrHide": true, "qrcodeUrl": qrcodeUrl })
        } else {
          this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "暂无绑定方式" })
          this.$store.dispatch('networkWxBindPageShow', { "showOrHide": false, "qrcodeUrl": "" })
        }
      })
    },
    // 点击空白页，让安卓端红包中心页面消失
    onEmptyClick() {
      this.sendToClient('close?')
    }
  }
}
</script>

<style>
body {
  padding-top: 0%;
  margin: 0%;
}


#v3TopEmpty {
  width: 100vw;
  height: 30vh;
  /* background: transparent; */
  /* background-color: #0505056f; */
  /* background-color: #00000000; */

  /* opacity:0.5;
    filter:alpha(opacity=0);
    background:#fff; */

}

#v3MainContent {
  width: 100vw;
  height: 70vh;
  background-color: #F6F6F6;
}

#v3Menu {
  position: fixed;
  width: 15vw;
  height: 100%;
  background-color: #FFF3F3;
  z-index: 1666;
}

#v3Content {
  /* width: 80%; 用百分比的话，会在安卓端WebView加载后，整个界面左右上下滑动出一点空白，不好看。使用vw可以避免这种情况 */
  width: 85vw;
  height: 70vh;
  /* height: 100%; */
  /* overflow-y:auto; */
  float: right;
  display: flex;
  flex-flow: column;
}
</style>



// WEBPACK FOOTER //
// src/views/SdkV3/SdkV3App.vue